import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Modal from 'react-bootstrap/Modal';
import "./index.scss";

import ProfileAvatar from "../../../../../components/ui/ProfileAvatar";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import Button from "../../../../../components/ui/Button";
import RadioButton from "../../../../../components/ui/RadioButton";
import DropDown from "../../../../../components/ui/DropDown";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import OverflowText from "../../../../../components/ui/Textoverflow";

import SubDomainInformation from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/SubDomain/SubDomainInformation";
import DNSRecordInformation from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/SubDomain/DNSRecordInformation";
import Technologies from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/SubDomain/Technologies";
import SSLCertificate from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/IPAddress/SSLCertificate";

import { filterIcon, searchIcon } from "../../../../../utils/icons";
import { formatNumber, getWebserverImageUrl } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getSubdomainList, getScanInfoStats, resetScanInfoStats, resetSubdomainList } from "../../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../../apiEndpoints";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const httpStatusOption = [    
    {
        label: "Active",
        value: "active"
    },
    {
        label: "Inactive",
        value: "inactive"
    },
    {
        label: "All",
        value: "all"
    }
]


const SubDomain = () => {

    const subdomainListResponse = useSelector((state) => state.scanInfo?.subdomainList);
    const scanInfoStatsResponse = useSelector((state) => state.scanInfo?.scanInfoStats);    

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    
    const filterWrapperRef = useRef(null);

    const [activeTab, setActiveTab] = useState("subDomainInformation");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedSubdomain, setSelectedSubdomain] = useState("");
    const [scanNotFound, setScanNotFound] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [subDomainStats, setSubDomainStats] = useState("");
    const [showViewAllModal, setShowViewAllModal] = useState(false);
    const [selectedViewAll, setSelectedViewAll] = useState("");
    const [subdomainLists, setSudomainLists] = useState(null);
    const [statsloading, setStatsLoading] = useState(false);

    const [subDomainTypeListOption, setSubDomainTypeListOption] = useState([]);
    const [webserverTypeOption, setWebserverTypeoption] = useState([]);

    // search value
    const [subdomainSearch, setSubdomanSearch] = useState("");
    const [updatedSubdomainSearchValue, setUpdatedSubdomainSearchValue] = useState("");

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [selectedHttpStatus, setSelectedHttpStatus] = useState("");
    const [selectedHttpsStatus, setSelectedHttpsStatus] = useState("");
    const [selectedSubdomainType, setSelectedSubdomainType] = useState("");
    const [selectedWebserverType, setSelectedWebserverType] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setContextCurrentPage(newPage);
        setTriggerListFetch(true);
    };

    const applyFilter = () => {
        setCurrentPage(1);        
        setShowFilter(false);
        let obj = {
            findings: newFindingsType,
            httpStatus: selectedHttpStatus,
            httpsStatus: selectedHttpsStatus,
            subdomainType: selectedSubdomainType,
            webserverType: selectedWebserverType
        }
        setSelectedFilterValue(obj);
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("")
        setSelectedHttpStatus("")
        setSelectedSubdomainType("")
        setSelectedWebserverType("")
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const fetchSubDomainStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.subDomain.subDomainStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        const url = `${baseUrl}${params}`
        dispatch(getScanInfoStats(url))
    },[dispatch, domainId, scanId, organizationId])

    const requestSearch = useMemo(() => debounce((searchTerm) => {        
        setUpdatedSubdomainSearchValue(searchTerm)
    }, 500), []);

    const fetchSubDomainList = useCallback(()=>{
        const baseUrl = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&page=${currentPage}&page_size=10&organization_id=${organizationId}`: `&page=${currentPage}&page_size=10&domain=${domainId}&scan_id=${scanId}`;
        const queryParams = updatedSubdomainSearchValue ? `&query=${updatedSubdomainSearchValue}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const httpStatus = selectedFilterValue.httpStatus && selectedFilterValue.httpStatus !== "all" ? `&http_status=${selectedFilterValue.httpStatus}` : "" ;
        const httpsStatus = selectedFilterValue.httpsStatus && selectedFilterValue.httpsStatus !== "all" ? `&https_status=${selectedFilterValue.httpsStatus}` : "" ;
        const subdomainType = selectedFilterValue.subdomainType ? `&subdomain_type=${selectedFilterValue.subdomainType}` : ""
        const webserverType = selectedFilterValue.webserverType ? `&webserver_type=${selectedFilterValue.webserverType}` : ""
        const url = `${baseUrl}${queryParams}${newFindings}${httpStatus}${httpsStatus}${subdomainType}${webserverType}`
        setIsLoading(true);
        setScanNotFound(false);
        dispatch(getSubdomainList(url))
    },[dispatch, domainId, scanId, currentPage, organizationId, updatedSubdomainSearchValue, selectedFilterValue])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }        
        }
    },[showFilter])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchSubDomainStats();
            setCurrentPage(1)
            setContextCurrentPage(1)
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setContextCurrentPage, setTriggerStatsFetch, fetchSubDomainStats]);

    useEffect(() => {
        if (triggerListFetch) {
            fetchSubDomainList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchSubDomainList]);

    useEffect(() => {
        setCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedSubdomainSearchValue]);

    useEffect(()=>{
        if(subdomainListResponse !== null) {
            setSudomainLists(subdomainListResponse)
            if(subdomainListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            if(subdomainListResponse?.results?.length > 0) {
                setSelectedSubdomain(subdomainListResponse?.results[0])
            }            
            setIsLoading(false);
            dispatch(resetSubdomainList())
        }
    },[subdomainListResponse, dispatch])

    useEffect(()=>{
        if(scanInfoStatsResponse !== null) {
            setStatsLoading(false)
            setSubDomainStats(scanInfoStatsResponse)
            if(scanInfoStatsResponse?.subdomain_type?.records && Object.entries(scanInfoStatsResponse?.subdomain_type?.records).length > 0) {
                let list = Object.entries(scanInfoStatsResponse?.subdomain_type?.records).map(([key]) => {
                    return {
                        label: key,
                        value: key
                    }
                })
                setSubDomainTypeListOption(list)
            } else {
                setSubDomainTypeListOption([])
            }

            if(scanInfoStatsResponse?.webserver_type?.records && Object.entries(scanInfoStatsResponse?.webserver_type?.records).length > 0) {
                let list = Object.entries(scanInfoStatsResponse?.webserver_type?.records).map(([key]) => {
                    return {
                        label: key,
                        value: key
                    }
                })
                setWebserverTypeoption(list)
            } else {
                setWebserverTypeoption([])
            }
            dispatch(resetScanInfoStats())
        }
    },[scanInfoStatsResponse, dispatch])

    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>
                        <Col lg={4}>
                            <div className="discover-doamin-container rounded p-3 h-100">
                                {
                                    statsloading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Subdomains</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(subDomainStats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(subDomainStats?.record_type?.new_record)}</span> New</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(subDomainStats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                }                                
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="sub-domain-type-container rounded p-3 h-100">
                                {
                                    statsloading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Subdomain Type</p>
                                            {subDomainStats !== "" && subDomainStats?.subdomain_type?.records && Object.entries(subDomainStats?.subdomain_type?.records).length > 4 && <p className="view-all" onClick={()=>{
                                                setSelectedViewAll("Subdomain Type")
                                                setShowViewAllModal(true)
                                            }}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(subDomainStats?.subdomain_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <Row className="mt-3">
                                            {
                                                subDomainStats !== "" && subDomainStats?.subdomain_type?.records && Object.entries(subDomainStats?.subdomain_type?.records).length > 0 &&
                                                Object.entries(subDomainStats?.subdomain_type?.records).map(([key, value], index) => {
                                                    if(index <= 3) {
                                                        return (
                                                            <Col lg={6} key={`subdomainType-${index}`}>
                                                                <p className="count-type sensitive-expo-count mt-2">
                                                                {formatNumber(value)} <span>{key}</span>
                                                                </p>
                                                            </Col>
                                                        )
                                                    }
                                                    return null;
                                                })
                                            }
                                        </Row>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="sub-domain-type-container web-server-type-container rounded p-3 h-100">
                                {
                                    statsloading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"subdomain"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Webserver Type</p>
                                            {subDomainStats !== "" && subDomainStats?.webserver_type?.records && Object.entries(subDomainStats?.webserver_type?.records).length > 4 && <p className="view-all" onClick={()=>{
                                                setSelectedViewAll("Webserver Type")
                                                setShowViewAllModal(true)
                                            }}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(subDomainStats?.webserver_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <div className="sub-domain-content">
                                            <Row className="mt-3">
                                                {
                                                    subDomainStats !== "" && subDomainStats?.webserver_type?.records && Object.entries(subDomainStats?.webserver_type?.records).length > 0 &&
                                                    Object.entries(subDomainStats?.webserver_type?.records).map(([key, value], index) => {
                                                        if(index <= 3) {
                                                            return (
                                                                <Col lg={6} key={`webserve-${index}`}>
                                                                    <div className="d-flex align-items-center gap-3 mt-2">
                                                                        <p className="count-type">{formatNumber(value)}</p>
                                                                        <ProfileAvatar type="domain" name={key} imageUrl={getWebserverImageUrl(key)} />
                                                                    </div>
                                                                </Col>
                                                            )
                                                        }
                                                        return null
                                                    })
                                                }
                                            </Row>
                                        </div>
                                    </motion.div>
                                }                                
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={3}>
                            <div className="bg-white-with-shadow subdomain-list-container h-100">
                                <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                    <h1>Subdomain List</h1>
                                    {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                    <div className="position-relative">                                        
                                        <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                            <h6>New Findings</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    newFindingsOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={`new-${index}`} isChecked={data.value === newFindingsType} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <h6>HTTP Status</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    httpStatusOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={`http-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedHttpStatus(value)}} key={`http1-${index}`} isChecked={data.value === selectedHttpStatus} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <h6>HTTPS Status</h6>
                                            <div className="filter-user-status d-flex mb-4 gap-4">
                                                {
                                                    httpStatusOption.map((data,index)=>{
                                                        return (
                                                            <RadioButton radioId={`https-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setSelectedHttpsStatus(value)}} key={`http1-${index}`} isChecked={data.value === selectedHttpsStatus} />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <h6>Subdomain Type</h6>
                                            <DropDown 
                                                placeHolder={"Subdomain Type"}
                                                options={subDomainTypeListOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedSubdomainType(data.value)}}
                                                defaultSelectedValue={selectedSubdomainType}
                                            />
                                            <h6 className="mt-4">Webserver Type</h6>
                                            <DropDown 
                                                placeHolder={"Webserver Type"}
                                                options={webserverTypeOption}
                                                isMulti={false}
                                                isSearchable={false}
                                                onChange={(data)=>{setSelectedWebserverType(data.value)}}
                                                defaultSelectedValue={selectedWebserverType}
                                            />
                                            <div className="filter-apply-btn mt-3">
                                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === "" && selectedHttpStatus === "" && selectedHttpsStatus === "" && selectedSubdomainType === "" && selectedWebserverType === ""} buttonClicked={()=>{applyFilter()}}/>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                                <div className="search-container px-3 position-relative">
                                    <span className="position-absolute search-icon">{searchIcon()}</span>
                                    <input type="text" 
                                        placeholder="Search" 
                                        className="w-100 rounded input" 
                                        value={subdomainSearch}
                                        onChange={(e)=>{                                            
                                            setSubdomanSearch(e.target.value)
                                            requestSearch(e.target.value)
                                            setCurrentPage(1)
                                        }}
                                    />
                                </div>
                                <div className="list-main-container">
                                    { !isLoading && scanNotFound &&
                                        <NoDataFound noDataText={subdomainLists?.description}/>
                                    }
                                    {
                                        isLoading && !scanNotFound ?
                                            <SkeletonLoader type={"line"} count={4} currentPage={"subdomain"} />
                                        :
                                        (
                                            subdomainLists?.results?.length > 0 &&
                                            subdomainLists?.results?.map((data, index) => {
                                                return (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <div className={`sub-domain-list py-2 px-3 ${selectedSubdomain !== "" && selectedSubdomain?.id === data?.id ? "active" : ""}`} onClick={()=>{setSelectedSubdomain(data)}}>
                                                            <div className={`d-flex align-items-center subdomain-name gap-2 mb-2 ${!data?.new_record ? "full-width" : ""}`}>
                                                                <OverflowText text={data?.subdomain} className={"sub-domain-heading"}/>
                                                                {data?.new_record && <span className="new-subdomain">New</span>}
                                                            </div>
                                                            <p className="sub-domain-name">{data.domain}</p>
                                                            <span className={`subdomain-status ${data?.http_status?.http ? "active" : "inactive"}`}>{data?.http_status?.http ? "HTTP Active" : "HTTP Inactive"}</span>
                                                            <span className={`subdomain-status ${data?.http_status?.https ? "active" : "inactive"}`}>{data?.http_status?.https ? "HTTPS Active" : "HTTPS Inactive"}</span>
                                                            {/* not required for now */}
                                                            {/* {data?.blacklisted?.is_blacklisted && 
                                                                <div>
                                                                    <span className="subdomain-status blacklisted">Blacklisted</span>
                                                                </div>
                                                            } */}
                                                            
                                                        </div>
                                                    </motion.div>
                                                )
                                            })
                                        )
                                    }
                                    { !isLoading && subdomainLists?.results?.length > 0 &&
                                        <PaginationArrow 
                                            totalCount={subdomainLists?.meta?.total_results}
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                        />
                                    }
                                    { !isLoading && subdomainLists?.results?.length === 0 &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"No Data Found"}/>
                                        </motion.div>                                        
                                    }                                                                                                           
                                </div>
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div className="bg-white-with-shadow sub-domain-main-container p-3 h-100">
                                <div className="tab-container d-flex rounded">
                                    <p className={`rounded text-center ${activeTab === "subDomainInformation" ? "active" : ""}`} onClick={()=>{setActiveTab('subDomainInformation')}}>Subdomain Information</p>
                                    <p className={`rounded text-center ${activeTab === "DNSRecordInformation" ? "active" : ""}`} onClick={()=>{setActiveTab('DNSRecordInformation')}}>DNS Record Information</p>
                                    <p className={`rounded text-center ${activeTab === "technologies" ? "active" : ""}`} onClick={()=>{setActiveTab('technologies')}}>Technologies</p>
                                    <p className={`rounded text-center ${activeTab === "SSLCertificate" ? "active" : ""}`} onClick={()=>{setActiveTab('SSLCertificate')}}>SSL Certificate</p>
                                </div>
                                <div className="tab-details-content mt-3">
                                    {   !isLoading && scanNotFound ?
                                        <NoDataFound noDataText={subdomainLists?.description}/>
                                        :
                                        ( !isLoading && subdomainLists?.results?.length === 0 ?
                                            <NoDataFound noDataText={"No Data Found"}/>
                                            :
                                            isLoading ?
                                                <SkeletonLoader type={"line"} count={5} currentPage={"subdomain"}/>
                                            :
                                            <>
                                                {activeTab === "subDomainInformation" && <SubDomainInformation selectedSubdomain={selectedSubdomain} isLoading={isLoading} />}
                                                {activeTab === "DNSRecordInformation" && <DNSRecordInformation selectedSubdomain={selectedSubdomain} domainId={domainId} scanId={scanId} organizationId={organizationId} currentPageType={"subDomain"}/>}
                                                {activeTab === "technologies" &&<Technologies selectedSubdomain={selectedSubdomain} domainId={domainId} scanId={scanId} organizationId={organizationId}/>}
                                                {activeTab === "SSLCertificate" && <SSLCertificate sslData={selectedSubdomain} domainId={domainId} scanId={scanId} organizationId={organizationId} currentPageType={"subdomain"}/>}
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Modal
                        show={showViewAllModal}
                        onHide={()=>setShowViewAllModal(false)}
                        size="md"
                        centered
                        className=""
                        >
                            <Modal.Body>
                                <div className="delete-organization-container">
                                    <h4>{selectedViewAll}</h4>
                                    <div className="p-2 m-2 type-list-container">
                                        { selectedViewAll === "Subdomain Type" ?
                                            <div className="mt-3">
                                            {
                                                subDomainStats !== "" && subDomainStats?.subdomain_type?.records && Object.entries(subDomainStats?.subdomain_type?.records).length > 0 &&
                                                Object.entries(subDomainStats?.subdomain_type?.records).map(([key, value], index) => {
                                                    return (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, y: 20 }}
                                                            animate={{ opacity: 1, y: 0 }}
                                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                                        >
                                                            <div>
                                                                <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom scan-info-type-modal">
                                                                    <p className="modal-key">{key}</p>
                                                                    <p className="count-type total-count">{formatNumber(value)}</p> 
                                                                </div>                                                            
                                                            </div>
                                                        </motion.div>                                                        
                                                    )                                         
                                                })
                                            }
                                            </div>
                                            :
                                            <div className="mt-3">
                                                {
                                                    subDomainStats !== "" && subDomainStats?.webserver_type?.records && Object.entries(subDomainStats?.webserver_type?.records).length > 0 &&
                                                    Object.entries(subDomainStats?.webserver_type?.records).map(([key, value], index) => {
                                                        return (
                                                            <motion.div
                                                                key={index}
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                                            >
                                                                <div>
                                                                    <div className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom scan-info-type-modal">                                                                    
                                                                        <ProfileAvatar type="domain" name={key} imageUrl={getWebserverImageUrl(key)} />
                                                                        <p className="count-type total-count">{formatNumber(value)}</p>
                                                                    </div>
                                                                </div>
                                                            </motion.div>
                                                            
                                                        )                                          
                                                    })
                                                }
                                            </div>
                                        
                                        }
                                    </div>
                                    <div className="d-flex justify-content-center gap-3 mt-4">
                                        <div className="w-50">
                                            <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowViewAllModal(false)}/>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                    </Modal>
                </div>
            </div>
        </>        
    )
}


export default SubDomain;